import { openBlock as t, createElementBlock as l, createStaticVNode as e } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ e('<path fill="#FFDA44" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#A2001D" d="M40 20c0-6.864-3.459-12.92-8.727-16.522H8.727C3.458 7.08 0 13.136 0 20c0 6.864 3.459 12.92 8.728 16.522h22.544C36.543 32.92 40 26.864 40 20Z"></path><path fill="#FFDA44" d="M15.652 14.783h8.696v-3.479l-1.739.87L20 9.565l-2.608 2.609-1.74-.87v3.479ZM27.826 20H23.48a2.007 2.007 0 1 0-3.506-1.948A2.006 2.006 0 1 0 16.468 20h-4.294c0 1.33 1.158 2.408 2.488 2.408h-.08a2.41 2.41 0 0 0 1.72 2.308l-1.954 1.954 1.844 1.845 2.617-2.617c.103.038.209.068.318.088l-1.58 3.57c.757.309 1.585.48 2.453.48.869 0 1.697-.171 2.454-.48l-1.58-3.57c.109-.02.215-.05.317-.088l2.617 2.617 1.844-1.845-1.954-1.954a2.409 2.409 0 0 0 1.72-2.308h-.08c1.33 0 2.488-1.078 2.488-2.408Z"></path><path fill="#6DA544" d="m20 21.304-2.826 1.305v2.608L20 26.957l2.826-1.74V22.61L20 21.304Z"></path><path fill="#0052B4" d="M17.174 20h5.652v3.478h-5.652V20Z"></path>', 5), o = [
  c
];
function a(n, p) {
  return t(), l("svg", h, [...o]);
}
const r = { render: a };
export {
  r as default,
  a as render
};
